export default "__VITE_ASSET__S42qr33G__"